export default __webpack_public_path__ + "static/Entenda0031-e112d9800273826e3976c63596f913dc.jpg";